// Copyright 2017 Sorama B.V.

import { autoinject, bindable, computedFrom } from "aurelia-framework";
import { IAuthentication } from "libraries/Authentication/IAuthentication";
import { OpenIDUnauthorizedNavigationStrategy } from "libraries/Authentication/OpenIDUnauthorizedNavigationStrategy";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";
import { ClientStatus, IClientService } from "services/Client/IClientService";
import { ILicenseService } from "services/License/ILicenseService";
import { IServerStatusService, ServerStatus } from "services/Server/IServerStatusService";

@autoinject
export class ViewGuard {
    constructor(
        private readonly authentication: IAuthentication,
        private readonly clientService: IClientService,
        private readonly serverService: IServerStatusService,
        private readonly shellViewManager: ShellViewManager,
        private readonly licenseService: ILicenseService,
        private readonly unauthorizedStrategy: OpenIDUnauthorizedNavigationStrategy
    ) {}

    @bindable
    public viewModel: string;

    @bindable
    public model: unknown;

    @bindable
    public view: string;

    @bindable
    public checkStreaming = false;

    @bindable
    public checkClient = false;

    @bindable
    public checkSignIn = false;

    @bindable
    public checkOnline = false;

    public dismissIssues: boolean;

    @computedFrom("checkSignIn", "authentication.isSignedIn")
    public get failedSignInCheck(): boolean {
        return !!this.checkSignIn && this.checkSignIn && !this.authentication.isSignedIn;
    }

    @computedFrom("checkOnline", "serverService.status")
    public get failedOnlineCheck(): boolean {
        return !!this.checkOnline && this.checkOnline && this.serverService.status !== ServerStatus.Online;
    }

    @computedFrom("checkClient", "clientService.status")
    public get failedClientCheck(): boolean {
        return !!this.checkClient && this.checkClient && this.clientService.status === ClientStatus.NotAvailable;
    }

    @computedFrom("checkClient", "clientService.status")
    public get failedClientVersionCheck(): boolean {
        return !!this.checkClient && this.checkClient && this.clientService.status === ClientStatus.UnsupportedVersion;
    }

    @computedFrom("failedSignInCheck", "failedClientCheck", "failedOnlineCheck", "failedClientVersionCheck")
    public get disableView(): boolean {
        return (
            this.failedSignInCheck || this.failedOnlineCheck || this.failedClientCheck || this.failedClientVersionCheck
        );
    }

    public signIn(): void {
        // Redirect to the unauthorized page for sign in
        this.unauthorizedStrategy.navigate();
    }

    public checkServerStatus(): void {
        this.serverService.updateStatus();
    }

    public showClientConnectionHelp(): void {
        // this.shellViewManager.openRightSideBar(ClientWorkflowModuleCatalog.HelpModule,[
        //     {
        //         prefix:SidebarRouter.prefix,
        //         name:"topicName",
        //         value: TechnicalGuidanceCatalog.ClientTroubleshootingModule
        //     }]
        //     );
    }

    public showClientUpdate(): void {
        //this.shellViewManager.openRightSideBar(ClientUpdateModule.moduleName);
    }

    public showHardwareStatus(): void {
        //this.shellViewManager.openRightSideBar(HardwareSelectionModule.moduleName);
    }

    public dismiss(event: Event): void {
        this.dismissIssues = true;
        event.stopPropagation();
    }
}
